import colors from '../tokens/colors';

export const selectGetolo = {
  base: {
    option: {
      color: colors.PROFESSIONAL_LIGHT_BLUE,
      backgroundColor: {
        hover: colors.CLEAR_LIGHT_BLUE,
        selected: colors.CLEAR_LIGHT_BLUE,
      },
    },
  },
  states: {
    hover: {}, // used from `input.style.js`
    focus: {}, // used from `input.style.js`
    focusVisible: {}, // used from `input.style.js`
    disabled: {}, // used from `input.style.js`
  },
};

export const selectDaDirekt = {
  base: {
    option: {
      color: colors.PROFESSIONAL_BLUE,
      backgroundColor: {
        hover: colors.CLEAR_LIGHT_BLUE,
        selected: colors.CLEAR_LIGHT_BLUE,
      },
    },
  },
  states: {
    hover: {}, // used from `input.style.js`
    focus: {}, // used from `input.style.js`
    focusVisible: {}, // used from `input.style.js`
    disabled: {}, // used from `input.style.js`
  },
};

export const selectDaKaufland = {
  base: {
    option: {
      color: colors.DA_KAUFLAND_BLACK,
      backgroundColor: {
        hover: colors.DA_KAUFLAND_LIGHT_GRAY,
        selected: colors.DA_KAUFLAND_LIGHT_GRAY,
      },
    },
  },
  states: {
    hover: {}, // used from `input.style.js`
    focus: {}, // used from `input.style.js`
    focusVisible: {}, // used from `input.style.js`
    disabled: {}, // used from `input.style.js`
  },
};

export const selectFressnapf = {
  base: {
    option: {
      color: colors.FRESSNAPF_TEXT_PRIMARY,
      backgroundColor: {
        hover: colors.FRESSNAPF_YELLOWISH_GREEN_LIGHT,
        selected: colors.FRESSNAPF_YELLOWISH_GREEN_LIGHT,
      },
    },
  },
  states: {
    hover: {}, // used from `input.style.js`
    focus: {}, // used from `input.style.js`
    focusVisible: {}, // used from `input.style.js`
    disabled: {}, // used from `input.style.js`
  },
};
